import { useEffect, useState } from "react";
import { TextView } from "../../view-form-components/text-view";
import { api } from "../../../redux/apis/api";
import { DocumentView } from "../../view-form-components/image.view";

const CustomerPaymentViewModal = ({
  isOpen = false,
  onClose = () => {},
  listFnc = () => {},
  selectID,
  deleteDisable = true,
}) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();

  const fetchData = () => {
    setLoading(true);
    api
      .post(`/payment/view`, {
        id: selectID,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (selectID && isOpen === true) {
      fetchData();
    }
  }, [selectID, isOpen]);

  const deleteFnc = (id) => {
    api
      .post(`/payment/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        onClose();
        listFnc();
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center"
          onClick={handleOverlayClick}
        >
          <div
            className="bg-white rounded-lg shadow-lg max-w-[50rem] w-full md:p-8 p-4 relative"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
              <h2 className="text-xl font-semibold capitalize">
                Payment - view
              </h2>
              <div className="flex gap-3 items-center">
                <button
                  onClick={() => onClose()}
                  type="button"
                  className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                >
                  Cancel
                </button>
                {deleteDisable && (
                  <button
                    onClick={() => deleteFnc(selectID)}
                    type="button"
                    className="px-4 py-1 border-[2px] border-errorColor bg-errorColor text-white rounded"
                  >
                    Delete
                  </button>
                )}
              </div>
            </div>
            <section className="overflow-auto w-full h-[60vh]">
              <section className="w-full max-w-[40rem]">
                <div className="px-2">
                  <TextView
                    label={"Customer"}
                    value={data?.customer_id ?? "--"}
                  />
                </div>
                <div className="px-2">
                  <TextView label={"order"} value={data?.order_id ?? "--"} />
                </div>
                <div className="px-2">
                  <TextView
                    label={"amount paid"}
                    value={data?.amount_paid ?? "--"}
                  />
                </div>
                <div className="px-2">
                  <TextView
                    label={"payment date"}
                    value={data?.payment_date ?? "--"}
                  />
                </div>
                <div className="px-2">
                  <TextView
                    label={"payment mode"}
                    value={data?.payment_mode ?? "--"}
                  />
                </div>
                <div className="px-2">
                  <DocumentView
                    label={"payment photo"}
                    value={data?.payment_photo_url}
                  />
                </div>

                <div className="px-2">
                  <TextView
                    label={"cheque date"}
                    value={data?.cheque_date ?? "--"}
                  />
                </div>
                <div className="px-2">
                  <TextView label={"status"} value={data?.status ?? "--"} />
                </div>

                <div className="px-2">
                  <TextView
                    label={"transaction number"}
                    value={data?.transaction_number ?? "--"}
                  />
                </div>
                <div className="px-2">
                  <TextView
                    label={"refund_mode"}
                    value={data?.refund_mode ?? "--"}
                  />
                </div>
                <div className="px-2">
                  <DocumentView
                    label={"refund payment photo"}
                    value={data?.refund_photo_url}
                  />
                </div>
                <div className="px-2">
                  <TextView
                    label={"refund_upi"}
                    value={data?.refund_upi ?? "--"}
                  />
                </div>
                <div className="px-2">
                  <TextView
                    label={"refund_transaction_number"}
                    value={data?.refund_transaction_number ?? "--"}
                  />
                </div>
                <div className="px-2">
                  <TextView
                    label={"refund_account_number"}
                    value={data?.refund_account_number ?? "--"}
                  />
                </div>
                <div className="px-2">
                  <TextView
                    label={"refund_bank"}
                    value={data?.refund_bank ?? "--"}
                  />
                </div>
                <div className="px-2">
                  <TextView
                    label={"refund_ifsc"}
                    value={data?.refund_ifsc ?? "--"}
                  />
                </div>
              </section>
            </section>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomerPaymentViewModal;
